import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { FetchAuthSessionOptions, fetchAuthSession, fetchUserAttributes, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  /**
   * Returns true if user is logged in
   */
  public loginState: boolean = false;
  /**
   * Holds the error state while doing Federation signIn,; Stores error from Auth, cognito and OAuth
   */
  public errorState: { message: string } | null = null;
  /**
   * Current userInfo
   */
  private userInfo?: any;

  constructor(private nzMessageService: NzMessageService) { }

  /**
   * Logs user out
   */
  logout() {
    this.loginState = false;
    signOut();
  }

  /**
   * Method to get the userinfo
   */
  async fetchUserDetails(): Promise<any> {
    try {
      const user = await getCurrentUser();
      if (user) {
        const attributes = await fetchUserAttributes();
        this.userInfo = {...user, ...attributes};
      } else {
        console.log('No current user signed in.');
      }
    } catch (err: any) {
      this.nzMessageService.error(`${err} while getting current user info`);
    }
  }

  /**
   * Utility method to get the user details
   * @returns User Object
   */
  async getUserInfo(): Promise<any> {
    await this.fetchUserDetails();
    return this.userInfo;
  }

  /**
   * Method to validate login
   * @returns Promise
   */
  async validateLogin(): Promise<boolean> {
    try {
      const authSession = await fetchAuthSession({ forceRefresh: true } );
      if(authSession.credentials)  {
        this.loginState = true;
      }
      return true;
    } catch (error: any) {
      return false;
    }
  }

  /**
   * Method for Federated sign in via okta
   */
  public federatedOktaSignIn() {
    signInWithRedirect({
      provider: { custom: 'Okta' },
      customState: '/',
    }).catch((err: any) => {
      console.log('err', err);
    });
  }
}
